import React from 'react';
import {updateRedux} from "../../../config/Security";
import {connect, getStore} from "trim-redux";
import {defaultVariabls} from "../../../config";
import axios from "axios";
import LockOpenRoundedIcon from "@material-ui/icons/LockOpenRounded";
import Button from "@material-ui/core/Button/Button";
import Feature from "./Feature";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {withStyles} from "@material-ui/core/styles";
import {Styles} from "../../../config/design/styles";
import {Translate} from "../../../config/Translate";
import CircularProgress from "@material-ui/core/CircularProgress";


class LoginToUserAccountButton extends React.Component {
    classes = this.props.classes
    state = {
        loading:false
    }
    loginToUserAccount(){
        let {mobile_confirmed,user_id} = this.props;
        if(!!mobile_confirmed){
            this.setState({
                loading:true
            })
            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.get(`${defaultVariabls.url}/loginToUserAccount/${user_id}`, config)
                .then(async response => {
                    await localStorage.setItem('ADMIN_ACT',localStorage.getItem('ACT'));
                    await localStorage.setItem('ACT',response.data.accessToken);
                    await updateRedux();
                    let user = await getStore('user')
                    let username = user.mobile;
                    let login_token = user.login_token;
                    await window.location.replace(`${defaultVariabls.website}/loginFromPanel/${username}/${login_token}`);
                })
                .catch(error => {
                    this.setState({
                        loading:false
                    })
                });
        }else{
            this.props.enqueueSnackbar(Translate.userShouldConfirmMobileFirst, {
                variant: 'error',
            });
        }

    }
    render() {
        let {style} = this.props;
        let {loading} = this.state;
        return (
            <Feature check="login_to_user_account">
                <Button
                    style={style}
                    startIcon={loading ? <CircularProgress size={22}/> : <LockOpenRoundedIcon/>}
                    variant="outlined"
                    color="primary"
                    onClick={() => this.loginToUserAccount()}
                >
                    {Translate.loginToUserAccount}
                </Button>
            </Feature>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    primary_color: state.primary_color
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(LoginToUserAccountButton))));